<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { errorText } from './api.js';

  export let conversationId;
  export let api;
  const dispatch = createEventDispatcher();
  let checks = [], loading = true, busy = null, error = '', success = '', alive = false;

  function report(problem) {
    if (!alive || problem.name === 'AbortError') return;
    error = errorText(problem);
    if ([401, 403].includes(problem.status)) dispatch('denied', problem);
  }

  async function load() {
    loading = true; error = ''; success = '';
    try {
      const result = await api(`conversations/${conversationId}/templates/`);
      if (!alive) return;
      checks = result.verification || [];
      dispatch('changed', result.results);
    } catch (problem) { report(problem); }
    finally { if (alive) loading = false; }
  }

  async function refresh(row) {
    if (busy !== null || loading || !row.enabled || !row.refresh_enabled || row.refresh_pending) return;
    busy = row.template_id; error = ''; success = '';
    try {
      const result = await api(`templates/${row.template_id}/verification/`, { method: 'POST', body: {} });
      if (!alive) return;
      checks = checks.map(item => item.template_id === result.template_id ? result : item);
      success = result.refresh_pending ? 'Patikra suplanuota. Vėliau atnaujinkite būsenas.' : 'Patikra atidedama. Palaukite ir atnaujinkite būsenas.';
    } catch (problem) { report(problem); }
    finally { if (alive) busy = null; }
  }

  function date(value) { return value ? new Date(value).toLocaleString('lt-LT') : 'Dar netikrinta'; }
  onMount(() => { alive = true; void load(); return () => { alive = false; }; });
</script>

<section class="verification" aria-label="Šablonų patikra">
  <header><h3>Šablonų patikra</h3><button type="button" on:click={() => dispatch('close')}>Uždaryti šablonų patikrą</button></header>
  <p>Tikrinama tiekėjo patvirtinimo būsena. Šis veiksmas nesiunčia žinutės klientui ir neatnaujina sustabdytų siuntimų.</p>
  {#if error}<p class="error" role="alert">{error}</p>{/if}
  {#if success}<p role="status">{success}</p>{/if}
  {#if loading}<p role="status">Įkeliamos šablonų būsenos…</p>
  {:else}
    {#each checks as row (row.template_id)}
      <article>
        <h4>{row.key} · {row.language}</h4>
        <p>{row.eligible ? 'Patvirtinimas galioja.' : errorText({ code: row.eligibility_reason })}</p>
        <p>Paskutinė patikra: {date(row.checked_at)}<br />Patvirtinimas patikrintas: {date(row.verified_at)}</p>
        {#if row.error_code}<p class="error">{errorText({ code: row.error_code })}</p>{/if}
        {#if !row.refresh_enabled}<p>Automatinė patikra išjungta. Kreipkitės į IT.</p>
        {:else if !row.enabled}<p>Šablonas išjungtas vietiniuose nustatymuose.</p>
        {:else if row.refresh_pending}<p>Patikra suplanuota; jos vykdymas priklauso nuo veikiančio apdorojimo proceso.</p>{/if}
        <button type="button" disabled={busy !== null || !row.enabled || !row.refresh_enabled || row.refresh_pending} on:click={() => refresh(row)}>
          Tikrinti {row.key} · {row.language}
        </button>
      </article>
    {:else}<p>Šiam kanalui dar nėra užregistruotų šablonų.</p>{/each}
  {/if}
  <button type="button" disabled={loading || busy !== null} on:click={load}>Atnaujinti būsenas</button>
</section>

<style>
  .verification{padding:16px 24px;border-bottom:1px solid #e8d2bb;background:#fff7ef;max-height:40vh;overflow:auto;font-size:12px}
  header{display:flex;align-items:center;justify-content:space-between;gap:10px}h3,h4{margin:0}p{line-height:1.5;margin:10px 0}article{padding:12px 0;border-top:1px solid #ead9c8}
  button{font:inherit;border:1px solid #bfb7a8;border-radius:6px;padding:9px;background:#fff;color:#25231f;cursor:pointer}button:disabled{opacity:.5;cursor:not-allowed}.error{color:#922c19}
  :focus-visible{outline:2px solid #d95513;outline-offset:2px}@media(max-width:760px){.verification{padding:12px}}
</style>
